export default __webpack_public_path__ + "static/media/icon-exit-dark.bfd23e6c.svg";